<script>
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import Popper from "vue3-popper";
import { useToast } from "vue-toastification";
import { formatISO } from 'date-fns'

//components
import ArticleSelectIntoPhoto from '@/components/Core/Articles/ArticleSelectIntoPhoto'
import ArticleSelectIntoPhotoSeo from '@/components/Core/Articles/ArticleSelectIntoPhotoSeo'

import AuditLogs from '@/components/Core/AuditLog/AuditLogs.vue'
import ArticleTextEditor from './components/textEditorArticle'

import LoadingButton from '@/components/General/LoadingButton'
import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'
import CheckboxToggle from '@/ui/CheckboxToggle'

import Multiselect from 'vue-multiselect'
// Vue.component('multiselect', Multiselect)

import ComponentOptions from './components/componentOptions'

import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getArticle, unlockArticle, createArticle, saveArticle, addComponentArticle, getArticleComponents } from '@/services/serviceArticle';
import { createAlias, getStateOptions } from '@/services/serviceCommon';
import { getTagOptions } from '@/services/serviceTag';
import { getMutationOptions } from '@/services/serviceMutation';
import { getPhotoPreview } from '@/services/servicePhoto';
import { getComponentOptions } from '@/services/serviceComponent';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getCategoryChildsOptions } from '@/services/serviceArticleCategory';

//utils
import { zistiDiff } from '@/utils/auditLogs';

export default defineComponent({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ArticleEdit',
	mixins: [MixinGeneralFunct],
	components: {

		Datepicker
		, AuditLogs
		, ArticleSelectIntoPhoto
		, ArticleSelectIntoPhotoSeo
		, Popper
		, ComponentOptions
		, LoadingScreen
		, LoadingButton
		, ArticleTextEditor
		, Multiselect
		, Alert
		, CheckboxToggle
	},
	props: { 'auth': Object, 'secData': Object, 'params': Object },
	data() {

		return {
			metaData: [],

			isLoading: true,
			isLoadingTags: false,
			isSending: false,

			articleId: '',
			isNewRecord: true,

			//modals
			modalSelectPhoto: {},
			modalSelectPhotoId: '',

			modalSelectPhotoSeo: {},
			modalSelectPhotoSeoId: '',

			publish_upOptions: {
				locale: 'sk',
				format: 'd.M.YYYY HH:mm',
				//useCurrent: true,
				//showClear: true,
				//showClose: true,
			},

			publish_downOptions: {
				locale: 'sk',
				format: 'YYYY-MM-DD HH:mm',
				//useCurrent: true,
				//showClear: true,
				//showClose: true,
			},

			optionsAccessLevels: [],
			optionsCategories: [],
			optionsCategoriesSingle: [],
			optionsCategoriesChild: [],
			optionsStates: [],
			optionsMutations: [],
			optionsComponents: [],
			optionsTags: [],


			//form
			data: {},
			oldData: {},
			gallery: [],
			library: [],
			docs: [],
			photos: [],
			media: {},
			optionsGalleries: [],
			optionsLibraries: [],
			selectedGallery: '',
			selectedLibrary: '',
			selectedComponentId: '',

			//tabs
			tab1: '',
			tab2: '',
			tab3: '',
			tab4: '',
			tab5: '',
			tab6: '',
			tab7: '',
			tab8: '',

		}
	},

	mounted: function () {

		if (this.$route.params.id) {
			this.articleId = this.$route.params.id;
		}
		this.onLoadPage();

		this.tab1 = `tab${this.getRandomInt(99999999999)}`;
		this.tab2 = `tab${this.getRandomInt(99999999999)}`;
		this.tab3 = `tab${this.getRandomInt(99999999999)}`;
		this.tab4 = `tab${this.getRandomInt(99999999999)}`;
		this.tab5 = `tab${this.getRandomInt(99999999999)}`;
		this.tab6 = `tab${this.getRandomInt(99999999999)}`;
		this.tab7 = `tab${this.getRandomInt(99999999999)}`;
		this.tab8 = `tab${this.getRandomInt(99999999999)}`;

		this.modalSelectPhotoId = `modal${this.getRandomInt(999999999)}`;
		this.modalSelectPhotoSeoId = `modal${this.getRandomInt(999999999)}`;
	},

	methods: {
		// load data form
		onLoadPage: function () {

			this.isLoading = true

			if (this.articleId && this.articleId > 0) {
				this.isNewRecord = false;
			} else if (!this.articleId) {
				this.isNewRecord = true;
			}

			getArticle({ articleId: this.articleId }).then(response => {

				if (!response.statusText) {

					//hide loader
					this.isLoading = false
					this.metaData = response.metaData;
					this.data = response.data;
					this.oldData = response.oldData;

					if (this.data.publish_up) {
						this.data.publish_up_view = this.data.publish_up;
					}
					if (this.data.publish_down) {
						this.data.publish_down_view = this.data.publish_down;
					}

					if (this.oldData.publish_up) {
						this.oldData.publish_up = formatISO(new Date(this.oldData.publish_up), 'yyyy-MM-dd HH:mm:ss');
					}
					if (this.oldData.publish_down) {
						this.oldData.publish_down = formatISO(new Date(this.oldData.publish_down), 'yyyy-MM-dd HH:mm:ss');
					}

					if (this.data.photo) {
						this.photoData(this.data.photo);
					}

					if (this.data.photoSeo) {
						this.photoDataSeo(this.data.photoSeo);
					}

				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getTagOptions({ searchName: '' }).then(response => {
				if (!response.statusText) {
					this.optionsTags = response.optionsTags;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getMutationOptions().then(response => {
				if (!response.statusText) {
					this.optionsMutations = response.optionsMutations;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getComponentOptions().then(response => {
				if (!response.statusText) {
					this.optionsComponents = response.optionsComponents;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if (!response.statusText) {
					this.optionsAccessLevels = response.optionsAccessLevels;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if (!response.statusText) {
					this.optionsStates = response.optionsStates;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getCategoryChildsOptions().then(response => {
				if (!response.statusText) {
					this.optionsCategories = response.optionsCategories;
					this.optionsCategoriesSingle = this.optionsCategories.filter(item => !item.subs);
					this.optionsCategoriesChild = this.optionsCategories.filter(item => item.subs);
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});



		},

		updateComponents: function () {
			getArticleComponents({ articleId: this.articleId }).then(response => {
				if (!response.statusText) {
					this.data.components = response.components;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},

		checkSave: function () {

			if (!this.data.title) { this.data.titleError = true; } else { this.data.titleError = false; }
			if (!this.data.alias) { this.data.aliasError = true; } else { this.data.aliasError = false; }
			if (!this.data.category) { this.data.categoryError = true; } else { this.data.categoryError = false; }
			if (!this.data.publish_up_view) { this.data.publish_upError = true; } else { this.data.publish_upError = false; }
			if (!this.data.state) { this.data.stateError = true; } else { this.data.stateError = false; }
			if (!this.data.language) { this.data.languageError = true; } else { this.data.languageError = false; }
			if (!this.data.access) { this.data.accessError = true; } else { this.data.accessError = false; }

			if (this.data.title && this.data.alias && this.data.category && this.data.state && this.data.language && this.data.access && !this.data.publish_upError) {
				return true;
			} else {
				return false;
			}
		},

		onSave: function () {

			if (this.checkSave()) {
				this.data.publish_up = formatISO(new Date(this.data.publish_up_view), 'yyyy-MM-dd HH:mm:ss');
				this.data.publish_down = this.data.publish_down_view ? formatISO(new Date(this.data.publish_down_view), 'yyyy-MM-dd HH:mm:ss') : null;
				this.isSending = true;
				if (this.articleId) {
					saveArticle(this.data).then(response => {
						if (!response.statusText) {
							this.isSending = false
							if (response.resCode == 1) {
								zistiDiff(this.oldData, this.data, this.articleId, 2);
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								if (this.isNewRecord) {
									this.$router.push(`/article/${response.articleId}/edit`);
								}
							} else if (response.resCode == 0) {
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							} else if (response.resCode == 2) {
								this.toast.error(this.$t('msgCore.dataWasNotSaved'));
							} else if (response.resCode == 3) {
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						} else {
							this.isSending = false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				} else {
					createArticle(this.data).then(response => {
						if (!response.statusText) {
							this.isSending = false
							if (response.resCode == 1) {
								zistiDiff(this.oldData, this.data, this.articleId, 2);
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								if (this.isNewRecord) {
									this.$router.push(`/article/${response.articleId}/edit`);
								}
							} else if (response.resCode == 0) {
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							} else if (response.resCode == 2) {
								this.toast.error(this.$t('msgCore.dataWasNotSaved'));
							} else if (response.resCode == 3) {
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						} else {
							this.isSending = false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}
			} else {
				this.toast.warning(this.$t('msgCore.fillInAllData'));
			}

		},

		onSaveClose: function () {

			if (this.checkSave()) {

				this.data.publish_up = formatISO(new Date(this.data.publish_up_view), 'yyyy-MM-dd HH:mm:ss');
				this.data.publish_down = this.data.publish_down_view ? formatISO(new Date(this.data.publish_down_view), 'yyyy-MM-dd HH:mm:ss') : null;
				this.isSending = true;
				if (this.articleId) {
					saveArticle(this.data).then(response => {
						if (!response.statusText) {
							this.isSending = false
							if (response.resCode == 1) {
								zistiDiff(this.oldData, this.data, this.articleId, 2);
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.onClose(this.data.id);
							} else if (response.resCode == 0) {
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							} else if (response.resCode == 2) {
								this.toast.error(this.$t('msgCore.dataWasNotSaved'));
							} else if (response.resCode == 3) {
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						} else {
							this.isSending = false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}
			} else {
				this.toast.warning(this.$t('msgCore.fillInAllData'));
			}

		},

		onClose: function () {
			if (this.articleId) {
				unlockArticle({ articleId: this.articleId }).then(response => {
					console.log(response)
					if (!response.statusText) {
						this.isLoading = false
						if (response.resCode == 1) {
							//	this.toast.success(this.$t('msgCore.dataWasUnlocked'));
							this.$router.push(`/articles`);
						} else if (response.resCode == 0) {
							//	this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
						} else if (response.resCode == 2) {
							this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
						} else if (response.resCode == 3) {
							this.toast.error(this.$t('msgCore.accessDenied'));
						}

					} else {
						this.isLoading = false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			} else {
				this.$router.push(`/articles`);
			}
		},

		onAddComponent: function () {

			if (this.selectedComponentId) {

				addComponentArticle({ articleId: this.articleId, selectedComponentId: this.selectedComponentId }).then(response => {
					console.log(response)
					if (!response.statusText) {
						this.isSending = false
						if (response.resCode == 1) {
							this.toast.success(this.$t('msgCore.dataWasSaved'));
							this.onLoadPage();
						} else if (response.resCode == 0) {
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						} else if (response.resCode == 2) {
							this.toast.error(this.$t('msgCore.dataWasNotSaved'));
						} else if (response.resCode == 3) {
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					} else {
						this.isSending = false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

			} else {
				this.toast.warning(this.$t('msgCore.selectComponent'));
			}

		},



		onCreateAlias: function () {

			if (this.data.title && this.isNewRecord) {

				createAlias({ articleName: this.data.title }).then(response => {
					if (!response.statusText) {
						this.data.alias = response.alias;
					} else {
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

			}
		},

		resetIntroducePhoto: function () {
			this.data.photo = '';
			this.media.photoData = '';
		},

		resetIntroducePhotoSeo: function () {
			this.data.photoSeo = '';
			this.media.photoDataSeo = '';
		},

		//modal box data select photo
		loadModalFormAddIntroducePhoto: function () {
			this.cSession();
			this.modalSelectPhoto = new bootstrap.Modal(document.getElementById(this.modalSelectPhotoId), { backdrop: 'static' })
			this.modalSelectPhoto.show();
		},

		//modal box data select photoSeo
		loadModalFormAddIntroducePhotoSeo: function () {
			this.cSession();
			this.modalSelectPhotoSeo = new bootstrap.Modal(document.getElementById(this.modalSelectPhotoSeoId), { backdrop: 'static' })
			this.modalSelectPhotoSeo.show();
		},

		//natiahne udaje k vybranej fotke
		photoData: function (photoId) {

			getPhotoPreview({ photoId }).then(response => {
				if (!response.statusText) {
					this.media.photoData = response.photoData;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		//natiahne udaje k vybranej Seo fotke
		photoDataSeo: function (photoId) {

			getPhotoPreview({ photoId }).then(response => {
				if (!response.statusText) {
					this.media.photoDataSeo = response.photoData;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		//akcia po vybere fotky
		reloadAfterSelect(e) {
			//console.log(e);
			this.data.photo = e;
			this.photoData(e);
		},

		//akcia po vybere SEO fotky
		reloadAfterSelectSeo(e) {
			//console.log(e);
			this.data.photoSeo = e;
			this.photoDataSeo(e);
		},



		//akcia po vymazani componentu
		onDeletedRecord: function () {
			this.updateComponents();
		},

		//akcia po radeni componentu UP
		onOrderRecord: function () {
			this.updateComponents();
		},


		handleChangeIntro(e) {
			this.data.short_text = e;
		},

		handleChangeFullText(e) {
			this.data.full_text = e;
		},

		// multiselect
		onSelectTag(option) {
			console.log(option)
		},

		addTag(newTag) {
			const tag = newTag;
			this.optionsTags.push(tag)
			this.data.tags.push(tag)
		},


		onSearchTags: function (searchName) {
			this.isLoadingTags = true;
			getTagOptions({ searchName }).then(response => {
				if (!response.statusText) {
					this.isLoadingTags = false;
					this.optionsTags = response.optionsTags;
				} else {
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		onChangeParamCreated: function (e) {
			this.data.param_show_date_created = e;
			console.log(e)
		},

		onChangeParamModiefied: function (e) {
			this.data.param_show_date_modified = e;
			console.log(e)
		}

	},

	watch: {
		articleId() {
			this.onLoadPage();
		},
		'data.title': function () {
			this.onCreateAlias();
		}
	},

	computed: {

	},

})

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>

		<div class="row">
			<div class="col-12">
				<h6>{{ $t('msgCore.Article') }} <span v-if="!data.isNewRecord"><b>{{ data.title }}</b> id: {{ data.id }}</span></h6>
			</div>
		</div>

		<div v-if="metaData.modulAccess && (auth.articlesNew || auth.articlesEdit)">

			<div class="row">
				<div class="col-12">
					<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
						<span class="angle-inner" :class="{ 'angle-warning': data.isCheckedOut }"><i class="fa"
								:class="{ 'angle-warning': data.isCheckedOut, 'fa-exclamation-triangle': data.isCheckedOut }"
								aria-hidden="true"></i> {{ $t('msgCore.Edited') }} </span>

						<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName + ', ' + data.isCheckedOutDate">
							<button class="personCircle v-center" v-bind:style="{ background: data.isCheckedOutColor }">{{
								data.isCheckedOutLetterName + '' + data.isCheckedOutLetterSurname }}</button>
						</Popper>

					</div>
				</div>
			</div>

			<div class="row">

				<div class="col-md-10 col-12">

					<div class="row">
						<div class="col-12">

							<ul class="nav nav-tabs" role="tablist">

								<li class="nav-item" role="presentation">
									<a class="nav-link active" :id="`${tab1}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab1}`"
										role="tab" :aria-controls="tab1" aria-selected="true">{{ $t('msgCore.basicData') }}</a>

								</li>

								<li class="nav-item" role="presentation">
									<a class="nav-link" :id="`${tab2}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab2}`" role="tab"
										:aria-controls="tab2" aria-selected="false">Úvodný obrázok</a>
								</li>

								<li class="nav-item">
									<a class="nav-link" :id="`${tab3}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab3}`" role="tab"
										:aria-controls="tab3" aria-selected="false">SEO obrázok</a>
								</li>

								<li class="nav-item">
									<a class="nav-link" :id="`${tab4}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab4}`" role="tab"
										:aria-controls="tab4" aria-selected="false">Úvodný text</a>
								</li>

								<li class="nav-item">
									<a class="nav-link" :id="`${tab5}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab5}`" role="tab"
										:aria-controls="tab5" aria-selected="false">Text</a>
								</li>

								<li class="nav-item">
									<a class="nav-link" :id="`${tab6}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab6}`" role="tab"
										:aria-controls="tab6" aria-selected="false">Špeciálne parametre</a>
								</li>

								<li v-show="!isNewRecord" class="nav-item">
									<a class="nav-link" :id="`${tab7}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab7}`" role="tab"
										:aria-controls="tab7" aria-selected="false">Komponenty obsahu</a>
								</li>

								<li class="nav-item" role="presentation">
									<a class="nav-link" :id="`${tab8}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab8}`" role="tab"
										:aria-controls="tab8" aria-selected="false">{{ $t('msgCore.AuditLogs') }}</a>
								</li>

							</ul>

						</div>
					</div>

					<div class="row">
						<div class="col-12">

							<div class="tab-content" id="myTabContent">

								<div :id="`${tab1}`" class="tab-pane active" role="tabpanel" :aria-labelledby="`${tab1}-tab`">

									<div class="row">

										<div class="col-md-5 col-12">
											<label :class="{ 'text-danger': data.titleError }"><b>{{ $t('msgCore.Title') }}</b> </label>
											<input type="text" class="form-control form-control-sm" :class="{ 'is-invalid': data.titleError }"
												v-on:change="checkSave()" v-model="data.title">
											<div v-show="data.titleError" class="error-input"><span
													class="badge badge-pill badge-danger">{{ $t('msgCore.fillIn') }}</span></div>
										</div>

										<div class="col-md-5 col-12">
											<label :class="{ 'text-danger': data.aliasError }"><b>{{ $t('msgCore.alias') }}</b> </label>
											<input type="text" :disabled="!isNewRecord" class="form-control form-control-sm"
												v-on:change="checkSave()" :class="{ 'is-invalid': data.aliasError }" v-model="data.alias">
											<div v-show="data.aliasError" class="error-input"><span
													class="badge badge-pill badge-danger">{{ $t('msgCore.fillIn') }}</span></div>
										</div>

									</div>

									<div class="row">

										<div class="col-md-12 col-12">
											<label><b>Podtitulok</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.subTitle">

										</div>

										<div class="col-md-12 col-12">
											<label><b>{{ $t('msgCore.external_url') }}</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.external_url">

										</div>

										<div class="col-md-6 col-12">
											<label :class="{ 'text-danger': data.publish_upError }"><b>{{ $t('msgCore.publish_up') }}</b> </label>
											<Datepicker v-model="data.publish_up_view" format="d.M.yyyy HH:mm" :locale="$i18n.locale"
												@update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')"
												:selectText="$t('msgCore.Select')" :class="{ 'is-invalid': data.publish_upError }"></Datepicker>
											<div v-show="data.publish_upError" class="error-input"><span
													class="badge badge-pill badge-danger">{{ $t('msgCore.fillIn') }}</span></div>
										</div>

										<div class="col-md-6 col-12">
											<label><b>{{ $t('msgCore.publish_down') }}</b> </label>

											<Datepicker v-model="data.publish_down_view" format="d.M.yyyy HH:mm" :locale="$i18n.locale"
												:cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"></Datepicker>
										</div>


										<div class="col-md-4 col-12">
											<label :class="{ 'text-danger': data.categoryError }"><b>{{ $t('msgCore.Category') }}</b></label>

											<select v-model='data.category' class="form-control form-control-sm"
												:class="{ 'is-invalid': data.categoryError }" v-on:change="checkSave()">
												<option value="">{{ $t('msgCore.selectCategory') }}</option>

												<option v-for="(options) in optionsCategoriesSingle" :value="options.id" :key="options.id">{{
													options.title }}
												</option>

												<optgroup v-for="(option) in optionsCategoriesChild" :key="option.id" :label="option.title">

													<option v-for="(opt) in option.subs" :value="opt.id" :key="opt">{{ opt.title }}</option>

												</optgroup>

											</select>
											<div v-show="data.categoryError" class="error-input"><span
													class="badge badge-pill badge-danger">{{ $t('msgCore.selectCategory') }}</span></div>
										</div>



										<div class="col-md-4 col-12">
											<label><b>{{ $t('msgCore.Highlighted') }}</b></label>

											<div class="togglebutton">
												<label>
													<input v-model='data.selected' type="checkbox">
													<span class="toggle"></span>
												</label>
											</div>
										</div>

									</div>

									<div class="row">

										<div class="col-12">
											<label><b>{{ $t('msgCore.Tags') }}</b></label>

											<multiselect v-model="data.tags" :multiple="true" :searchable="true" :loading="isLoadingTags"
												:internal-search="false" :options="optionsTags" @select="onSelectTag" :taggable="true"
												@tag="addTag" selectedLabel="Vybrané" selectLabel="Stlač enter pre výber"
												deselectLabel="Stlač enter pre zrušenie" tagPlaceholder="Stlač enter pre vytvorenie tagu"
												placeholder="Vyber možnosť" @search-change="onSearchTags">


											</multiselect>

										</div>

									</div>

								</div>


								<div :id="`${tab2}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab2}-tab`">

									<div class="row">
										<div class="col-md-3 col-12">
											<a class="fancybox" data-fancybox="gallery" :href="media.photoData"><img :src="media.photoData"></a>
										</div>
									</div>

									<div class="row">
										<div class="col-md-3 col-12">
											<button type="button" :disabled="!auth.articlesAddPhoto"
												v-on:click="loadModalFormAddIntroducePhoto()" class="btn btn-primary btn-sm"><i
													class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnSelectPhoto') }}</button>

											<button v-if="data.photo" type="button" :disabled="!auth.articlesAddPhoto"
												v-on:click="resetIntroducePhoto()" class="btn btn-danger btn-sm"><i
													class="smire-icon fas fa-minus"></i> {{ $t('msgCore.btnStorno') }}</button>
										</div>
									</div>

								</div>

								<div :id="`${tab3}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab3}-tab`">

									<div class="row">
										<div class="col-md-3 col-12">
											<a class="fancybox" data-fancybox="gallery" :href="media.photoDataSeo"><img
													:src="media.photoDataSeo"></a>
										</div>
									</div>

									<div class="row">
										<div class="col-md-3 col-12">
											<button type="button" :disabled="!auth.articlesAddPhoto"
												v-on:click="loadModalFormAddIntroducePhotoSeo()" class="btn btn-primary btn-sm"><i
													class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnSelectPhoto') }}</button>

											<button v-if="data.photoSeo" type="button" :disabled="!auth.articlesAddPhoto"
												v-on:click="resetIntroducePhotoSeo()" class="btn btn-danger btn-sm"><i
													class="smire-icon fas fa-minus"></i> {{ $t('msgCore.btnStorno') }}</button>
										</div>
									</div>

								</div>


								<div :id="`${tab4}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab4}-tab`">
									<ArticleTextEditor :auth="auth" :secData="secData" :content="data.short_text"
										@changeContent="handleChangeIntro" />
								</div>

								<div :id="`${tab5}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab5}-tab`">
									<ArticleTextEditor :auth="auth" :secData="secData" :content="data.full_text"
										@changeContent="handleChangeFullText" />
								</div>

								<div :id="`${tab6}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab6}-tab`">

									<div class="row">
										<div class="col-md-4 col-12">
											<label><b>Farba pozadia titulku</b> </label>
											<input type="color" class="form-control form-control-sm" v-model="data.color_background_title">
										</div>

										<div class="col-md-4 col-12">
											<label><b>HEX tvar</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.color_background_title">
										</div>
									</div>

									<div class="row">
										<div class="col-md-4 col-12">
											<label><b>Farba textu titulku</b> </label>
											<input type="color" class="form-control form-control-sm" v-model="data.color_text_title">
										</div>

										<div class="col-md-4 col-12">
											<label><b>HEX tvar</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.color_text_title">
										</div>
									</div>

									<div class="row">
										<div class="col-12">
											<label><b>Brand logo k článku</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.url_logo_brand">
										</div>
									</div>

									<div class="row">
										<div class="col-12 col-md-6">
											<label><b>Zobraziť dátum vytvorenia</b> </label>
											<CheckboxToggle :key="`paramCreated${data.id}`" :data="data.param_show_date_created_isActive"
												@onClick="onChangeParamCreated"></CheckboxToggle>
										</div>

										<div class="col-12 col-md-6">
											<label><b>Zobraziť dátum aktualizácie</b> </label>
											<CheckboxToggle :key="`paramModified${data.id}`" :data="data.param_show_date_modified_isActive"
												@onClick="onChangeParamModiefied"></CheckboxToggle>
										</div>
									</div>

								</div>

								<div v-show="!isNewRecord" :id="`${tab7}`" class="tab-pane" role="tabpanel"
									:aria-labelledby="`${tab7}-tab`">

									<div class="row">

										<div class="col-12 col-md-6">
											<div class="input-group">
												<select v-model='selectedComponentId' class="form-select form-select-sm">
													<option value="">{{ $t('msgCore.selectComponent') }}</option>
													<option v-for="(options) in optionsComponents" :value="options.value" :key="options.value">{{
														$t('msgCore.' + options.title) }}</option>
												</select>
												<button type="button" v-on:click="onAddComponent()" class="btn btn-primary btn-sm">{{
													$t('msgCore.AddComponent') }}</button>
											</div>
										</div>

										<ComponentOptions :id="data.components.id" :key="data.components.id" :components="data.components"
											:articleId="articleId" @deleteRecord="onDeletedRecord" @orderRecord="onOrderRecord" />

										<div class="col-12 col-md-6 mt-2 mb-2">
											<div class="input-group">
												<select v-model='selectedComponentId' class="form-select form-select-sm">
													<option value="">{{ $t('msgCore.selectComponent') }}</option>
													<option v-for="(options) in optionsComponents" :value="options.value" :key="options.value">{{
														$t('msgCore.' + options.title) }}</option>
												</select>
												<button type="button" v-on:click="onAddComponent()" class="btn btn-primary btn-sm">{{
													$t('msgCore.AddComponent') }}</button>
											</div>
										</div>

									</div>

								</div>

								<div :id="`${tab8}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab8}-tab`">
									<div>
										<AuditLogs :auth="auth" :secData="secData" :currentDoc="data" typeId="2" :docId="String(articleId)">
										</AuditLogs>
									</div>
								</div>

							</div>

						</div>
					</div>

				</div>

				<div class="col-md-2 col-12 form-control-system-data">

					<div class="row">

						<div class="col-12">
							<label :class="{ 'text-danger': data.accessError }"><b>{{ $t('msgCore.AccessLevel') }}</b></label>

							<select v-model='data.access' class="form-control form-control-sm " :class="{ 'is-invalid': data.accessError }"
								v-on:change="checkSave()">
								<option value="">{{ $t('msgCore.selectLevel') }}</option>
								<option v-for="(option) in optionsAccessLevels" :value="option.value" :key="option">{{ option.title }}
								</option>
							</select>
							<div v-show="data.accessError" class="error-input"><span
									class="badge badge-pill badge-danger">{{ $t('msgCore.selectLevel') }}</span></div>
						</div>

						<div class="col-12">
							<label :class="{ 'text-danger': data.stateError }"><b>{{ $t('msgCore.State') }}</b></label>

							<div v-for="(option) in optionsStates" :key="option.value" class="form-check">
								<label class="form-check-label">
									<input class="form-check-input" type="radio" name="optionsStates" v-model='data.state'
										v-on:change="checkSave()" :value="option.value">
									{{ $t('msgCore.' + option.title) }}
									<span class="circle">
										<span class="check"></span>
									</span>
								</label>
							</div>
							<div v-show="data.stateError" class="error-input"><span
									class="badge badge-pill badge-danger">{{ $t('msgCore.selectState') }}</span></div>
						</div>

						<div class="col-12">
							<label :class="{ 'text-danger': data.languageError }"><b>{{ $t('msgCore.Language') }}</b></label>

							<select v-model='data.language' class="form-control form-control-sm"
								:class="{ 'is-invalid': data.languageError }" v-on:change="checkSave()">
								<option value="">{{ $t('msgCore.selectLanguage') }}</option>
								<option v-for="(option) in optionsMutations" :value="option.value" :key="option">{{
									$t('msgCore.' + option.title) }}</option>
							</select>
							<div v-show="data.languageError" class="error-input"><span
									class="badge badge-pill badge-danger">{{ $t('msgCore.selectLanguage') }}</span></div>
						</div>

					</div>

			</div>





		</div>

	</div>

	<div v-else>
		<div class="row">
			<div class="col-12 mt-3">
				<Alert type="warning" :label="$t('msgCore.accessDenied')" />
			</div>
		</div>
	</div>

	<div class="footer mt-2">

		<div class="btn-group">


			<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ !isNewRecord ?
				$t('msgCore.btnClose') : $t('msgCore.btnBack') }}</button>


			<LoadingButton v-if="isNewRecord" :isDisabled="(!auth.articlesNew || isSending || !metaData.modulAccess)"
				:isSending="isSending" @onClick="onSave" :label="'msgCore.btnCreate'" color="warning"></LoadingButton>

			<LoadingButton v-if="!isNewRecord" :isDisabled="(!auth.articlesEdit || isSending || !metaData.modulAccess)"
				:isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>

			<LoadingButton v-if="!isNewRecord" :isDisabled="(!auth.articlesEdit || isSending || !metaData.modulAccess)"
				:isSending="isSending" @onClick="onSaveClose" :label="'msgCore.btnSaveAndClose'" color="warning">
			</LoadingButton>
		</div>

	</div>







	<ArticleSelectIntoPhoto :auth="auth" :secData="secData" :articlePhotoId="String(data.photo)"
		@changeAfterSelect="reloadAfterSelect" :modalObject="modalSelectPhoto" :modalId="modalSelectPhotoId">
	</ArticleSelectIntoPhoto>

	<ArticleSelectIntoPhotoSeo :auth="auth" :secData="secData" :articlePhotoId="String(data.photoSeo)"
		@changeAfterSelect="reloadAfterSelectSeo" :modalObject="modalSelectPhotoSeo" :modalId="modalSelectPhotoSeoId">
	</ArticleSelectIntoPhotoSeo>




</div></template>

